module.exports = __webpack_public_path__ + "front/img/c11.c32f8190.png";